$('.js-sidenav-toggle').on('click', function(){
  $('.js-sidenav-toggle').toggleClass('is-active');
  $('.sidenav').toggleClass('is-active');
});

$('.js-dropdown-toggle').on('click', function(){
  $(this).toggleClass('is-active');
});